import React from 'react'
import { Container, FlexColumn, FlexRow } from 'components/common/Containers'
import HeroImage from './images/hero.svg'
import styles from './Watchlist.module.scss'
import WatchlistItem from './components/WatchlistItem/WatchlistItem'
import Spinner from 'components/common/Spinner/Spinner'

interface Props {
  watchlist:
    | {
        id: number
        keyword: string
        lookup_interval: 'daily' | 'weekly' | 'monthly'
      }[]
    | undefined
  onDelete: (id: number) => void
  isLoadingWatchlist: boolean
  isDeletingWatchlistItem: boolean
}

const Watchlist: React.FC<Props> = ({
  watchlist,
  onDelete,
  isDeletingWatchlistItem,
  isLoadingWatchlist,
}) => {
  return (
    <Container>
      <section className={styles.section}>
        <FlexRow className={styles.row} justify="space-between" gap="2rem">
          <FlexColumn className={styles.content} gap="10px" justify="center">
            <h2 className={styles.title}>Your watchlist</h2>

            {isLoadingWatchlist || isDeletingWatchlistItem ? (
              <Spinner size={40} />
            ) : watchlist?.length ? (
              <>
                <span className={styles.subtitle}>
                  You’ve already subscribed for alerts from these keywords
                </span>

                <FlexRow wrap="wrap" gap="15px" justify="flex-start">
                  {watchlist.map((el) => (
                    <WatchlistItem
                      key={el.id}
                      watchlistItem={el}
                      onDelete={onDelete}
                    />
                  ))}
                </FlexRow>
              </>
            ) : (
              <span>You are not subscribed to any keyword at the moment</span>
            )}
          </FlexColumn>

          <div className={styles.imageWrapper}>
            <HeroImage />
          </div>
        </FlexRow>
      </section>
    </Container>
  )
}

export default Watchlist
